<template>
  <a-modal
    title="次优解"
    :visible="visible"
    :destroyOnClose="true"
    :forceRender="true"
    :maskClosable="false"
    @cancel="cancel"
    @ok="ok"
    :width="formulaSolutionType === '0' ? '400px' : '900px'"
  >
    <a-table
      v-if="formulaSolutionType !== '0'"
      :columns="columns"
      :data-source="list"
      row-key="id"
      :pagination="false"
      :loading="loading"
      :scroll="{y: 400}"
    >
      <a-tooltip slot="name" slot-scope="t">
        <template slot="title">{{ t }}</template>
        {{ t }}
      </a-tooltip>
      <template slot="colorSpan" slot-scope="t,r">
        <span v-if="r.maxValue && t > r.maxValue" style="color: red;">
          {{ t || t === 0 ? Number(t).toFixed(precision(r.unit)) : t }}
        </span>
        <span v-else-if="r.minValue && t < r.minValue" style="color: green;">
          {{ t || t === 0 ? Number(t).toFixed(precision(r.unit)) : t }}
        </span>
        <span v-else>
          {{ t || t === 0 ? Number(t).toFixed(precision(r.unit)) : t }}
        </span>
      </template>
      <cell-editor
        v-for="(col,i) in ['minValue', 'maxValue']"
        slot-scope="text, record"
        :slot="col"
        :key="i"
        :background="true"
        :item="record" 
        :len="precision(record.unit)" 
        :name="col"
        @blur="target => itemUpdate(target,record.id,record,col)"
        :text="text"
      />
      
    </a-table>
    <span v-else>配方无解，请检查配方及营养指标约束。</span>
    <div slot="footer">
      <a-button v-if="formulaSolutionType !== '0'" @click="cancel">取消</a-button>
      <a-button v-if="formulaSolutionType !== '0'" @click="ok" type="primary" :loading="loading || btnLoading">应用</a-button>
      <a-button v-if="formulaSolutionType === '0'" @click="cancel" type="primary">知道了</a-button>
    </div>
  </a-modal>
</template>

<script>
import CellEditor from './CellEditor.vue'
import {rawsColumns,indexColumns} from './resultColumns';
import { nhfMixins } from "../../untils";
export default {
  components: {CellEditor},
  props: ['hidden','params'],
  mixins: [nhfMixins],
  data() {
    return {
      columns: [],
      rawsColumns,
      indexColumns,
      loading: false,
      btnLoading: false,
      list: [],
      listType: '',
      listId: '',
      formulaSolutionType: '',
    }
  },
  watch: {
    visible(val){
      if(val) {
        this.columns = []
        this.list = []
        this.listType = ''
        this.listId = ''
        this.formulaSolutionType = ''
        this.getList()
      }
    }
  },
  computed: {
    visible: {
      get(){
        return this.hidden
      },
      set(){}
    },
  },
  created() {},
  mounted() {},
  methods: {
    precision(unit){
      let num = 3
      if(this.listType === 'saveSuboptimalNutrition'){
        num = unit ==='MJ' || unit === 'Kcal'? 0 : 2
      }
      return num
    },
    cancel(){
      this.$emit('close')
    },
    async ok(){
      this.btnLoading = true
      this.loading = true
      const res = await this.fetchGet({
        actions: this[this.listType],
        data: {
          [this.listType === 'saveSuboptimalRaw' ? 'formulaRawRespList' : 'formulaNutritionRespList']: this.list,
          formulaId: this.listId,
          formulaSolutionType: this.formulaSolutionType,
        },
        showError: false,
      });
      this.btnLoading = false
      this.loading = false
      let {msg,success} = res || {}
      this.$message[success ? 'success' : 'warning'](msg)
      this.$emit('close',true)
    },
    itemUpdate(item,id){
      const newData = [...this.list]
      const targets = newData.filter(item => id === item.id)[0]
      if (targets) {
        Object.assign(targets, item)
        this.list = newData
      }
    },
    async getList(){
      this.loading = true
      const res = await this.fetchGet({
        actions: this.suboptimalByOptimization,
        data: this.params,
        showError: false,
      });
      this.loading = false
      let {formulaNutritionRespList,formulaRawRespList,formulaId,formulaSolutionType} = res?.data || {}
      this.listId = formulaId
      this.formulaSolutionType = formulaSolutionType
      if(formulaRawRespList && formulaRawRespList.length > 0) {
        this.listType = 'saveSuboptimalRaw'
        this.columns = this.rawsColumns
        this.list = [...formulaRawRespList] || []
      }
      if(formulaNutritionRespList && formulaNutritionRespList.length > 0) {
        this.listType = 'saveSuboptimalNutrition'
        this.columns = this.indexColumns
        this.list = formulaNutritionRespList || []
      }
    },
  },
}
</script>
<style lang="scss">
.optimizeModal{
  .ant-table-thead > tr > th, .ant-table-tbody > tr > td{
    padding: 5px 0;
  }
}
</style>
<style lang='scss' scoped></style>